<template>
  <div class="layout-row layout-wrap">
    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.register_id'" rules="required" v-slot="{ errors }">
        <v-select
          :dark="compColor.isInDarkMode"
          :color="compColor.primeColor"
          v-model="model.register_id"
          :items="registerArray"
          :dense="denseFields"
          item-text="name"
          outlined
          :hide-details="!errors || errors.length <= 0"
          item-value="id"
          :error-messages="errors[0]"
          :label="$t('COMPONENT_CANCER_MESSAGE_DETAILS.CANCER_REGISTER') + ' *'"
          :menu-props="{ bottom: true, offsetY: true }">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.name }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-66 flex-100 px-2">
      <div class="py-2 px-3 body-2 layout-row layout-align-start-center flex-gt-sm-100"
           v-if="!model.register_id"
           :class="[!compColor.isInDarkMode ? 'red' + ' lighten-5 white--text ' : '']"
           style="border:1px solid;border-radius: 9px;"
           :style="{'border-color': compColor.isInDarkMode ? '#E53935' : 'transparent'}"
      >
        <v-icon class="mr-3" :size="denseFields ? '24' : '30'" :color="'#E53935'">mdi-alert</v-icon>
        <span style="font-size: 18px;" :class="'red--text darken-1'"><small>{{ $t('WARNING_MISSING_CANCER_REGISTER') }}</small></span>
      </div>
    </div>

    <div class="flex-gt-sm-33 flex-100 px-2">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_CANCER_MESSAGE_DETAILS.CARE_PROVIDER')"
            outlined
            disabled
            v-model="username"
        ></v-text-field>
    </div>

    <div class="flex-gt-sm-33 flex-100 px-2" v-if="lanr">
      <v-text-field
          :dark="compColor.isInDarkMode"
          :color="compColor.primeColor"
          :dense="denseFields"
          :label="$t('COMPONENT_PHYSICIAN_DETAILS.LANR')"
          outlined
          disabled
          v-model="lanr"
      ></v-text-field>
    </div>

    <div class="flex-gt-sm-33 flex-100 px-2" v-if="iknr">
      <v-text-field
        :dark="compColor.isInDarkMode"
        :color="compColor.primeColor"
        :dense="denseFields"
        :label="$t('COMPONENT_PHYSICIAN_DETAILS.IK_NUMBER')"
        outlined
        disabled
        v-model="iknr"
      ></v-text-field>
    </div>

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.melder_id'" rules="required" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_CANCER_MESSAGE_DETAILS.MELDER_ID') + ' *'"
            outlined
            :error-messages="errors[0]"
            v-model="model.melder_id"
        ></v-text-field>
      </validation-provider>
    </div>

    <!-- Existiert eine BAG ? -->

    <div class="flex-gt-sm-100 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.isMedicalCommunity'" rules="">
        <v-checkbox :dark="compColor.isInDarkMode"
                    :color="compColor.primeColor"
                    class="mt-0 py-0"
                    hide-details
                    :label="$t('COMPONENT_CANCER_MESSAGE_DETAILS.IS_MEDICAL_COMMUNITY')"
                    v-model="model.isMedicalCommunity">
        </v-checkbox>
      </validation-provider>
    </div>

    <div class="flex-100 px-2 pb-4" v-if="model.isMedicalCommunity">
        <v-divider class="mb-2" :class="{'blue-grey lighten-4': !compColor.isInDarkMode, 'blue-grey darken-3': compColor.isInDarkMode}"></v-divider>
    </div>

    <div class="flex-gt-sm-33 flex-100 px-2" v-if="model.isMedicalCommunity">
      <validation-provider tag="div" :name="path + '.medicalCommunity.melderId'" rules="required" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_CANCER_MESSAGE_DETAILS.MELDER_ID_COMMUNITY') + ' *'"
            outlined
            :hint="'( ' + $t('COMPONENT_CANCER_MESSAGE_DETAILS.MELDER_ID_COMMUNITY_HINT') + ' )'"
            persistent-hint
            :error-messages="errors[0]"
            v-model="model.medicalCommunity.melderId"
        ></v-text-field>
      </validation-provider>
    </div>

    <!-- Liste aller zusätzlichen Leistungserbringer -->

    <div v-if="model.isMedicalCommunity" class="flex-gt-sm-100 pa-2 pt-5">

      <!-- Titel mit Sub-Text -->

      <div class="layout-column flex-100 px-3 py-1 mb-6" :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
           style="border-radius: 4px;">
        <span class="body-4 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('COMPONENT_CANCER_MESSAGE_DETAILS.MEDICAL_COMMUNITY_TITLE') }}</span>
        <span class="body-2" :style="{color: compColor.primeColor}">{{ $t('COMPONENT_CANCER_MESSAGE_DETAILS.MEDICAL_COMMUNITY_SUB_TEXT') }}</span>
      </div>

      <!-- Neuen Leistungserbringer hinzufügen -->

      <v-btn :dark="compColor.isInDarkMode" class="white--text text-none" :color="compColor.primeColor"
             @click="addPhysician" depressed :title="$t('buttons.add_physician.title_BAG')">
        <v-icon color="white" left>mdi-account-plus</v-icon>
        {{ $t('COMPONENT_CANCER_MESSAGE_DETAILS.OTHER_CARE_PROVIDER') }} {{ $t('buttons.add.value').toLowerCase() }}
      </v-btn>

      <!-- Leistungserbringer  -->

      <div :key="index" v-for="(item, index) in model.medicalCommunity.physicians"
           class="layout-row pa-0 my-2"
           :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
           style="border-radius:4px;"
           :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

        <div class="layout-row layout-wrap flex pt-3 px-4" v-if="index>0">
          <div class="flex-gt-sm-33 flex-100 pa-2 pb-0">
            <validation-provider tag="div" :name="path + '.medicalCommunity.physicians.' + index + '.name'" rules="required|min:2|name_string" v-slot="{ errors }">
              <v-text-field
                :dark="compColor.isInDarkMode"
                :color="compColor.primeColor"
                :dense="denseFields"
                outlined
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :label="$t('COMPONENT_CANCER_MESSAGE_DETAILS.PHYSICIAN_NAME')"
                v-model="item.name"
              ></v-text-field>
            </validation-provider>
          </div>

          <div class="flex-gt-sm-33 flex-100 pa-2 pb-0">
            <validation-provider tag="div" :name="path + '.medicalCommunity.physicians.' + index + '.lanr'"
                                 :rules="{required: true,lanr: true,lanr_must_be_unique: [model.medicalCommunity.physicians, index, lanr],decimal:true}" v-slot="{ errors }">
              <v-text-field
                  :dark="compColor.isInDarkMode"
                  :color="compColor.primeColor"
                  :dense="denseFields"
                  outlined
                  required
                  class="mb-1"
                  maxLength="9"
                  counter="9"
                  :error-messages="errors[0]"
                  :label="$t('COMPONENT_PHYSICIAN_DETAILS.LANR') + ' *'"
                  v-model="item.lanr"
              ></v-text-field>
            </validation-provider>
          </div>

          <div class="flex-gt-sm-33 flex-100 pa-2 pb-0">
            <validation-provider tag="div" :name="path + '.medicalCommunity.physicians.' + index + '.melderId'" rules="required|trim_string" v-slot="{ errors }">
              <v-text-field
                  :dark="compColor.isInDarkMode"
                  :color="compColor.primeColor"
                  :dense="denseFields"
                  outlined
                  :hide-details="!errors || errors.length <= 0"
                  :error-messages="errors[0]"
                  :label="$t('COMPONENT_CANCER_MESSAGE_DETAILS.MELDER_ID') + ' *'"
                  v-model="item.melderId"
              ></v-text-field>
            </validation-provider>
          </div>
        </div>

        <div class="layout-column layout-align-center-center px-3"
             v-if="index>0"
             :class="{'grey lighten-2': !compColor.isInDarkMode}"
             :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
          <lx-btn @click="deletePhysician(index)"
                  :color="compColor.primeColor"
                  :iconColor="'white'"
                  iconSize="21"
                  :width="35"
                  :height="35"
                  icon="delete_forever"></lx-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: 'RegisterDetails',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    lanr: {
      type: String
    },
    iknr: {
      type: String
    },
    username: {
      type: String
    },
    oldModel: {
      type: Object,
      default: () => ({ medicalCommunity: {} })
    }
  },
  created () {
    // get list of cancer register from db
    this.$http.get('/register?config={"opts":{"sort":{"name": 1}}}')
      .then(res => {
        if (res.data && res.data.result) {
          this.registerArray = res.data.result
        }
      })
      .catch(this.NotifyError)
  },
  data () {
    return {
      registerArray: [],
      model: {
        medicalCommunity: {}
      }
    }
  },
  methods: {
    triggerArrayChanges () {
      this.$emit('change', !lodash.isEqual(this.model.medicalCommunity.physicians, this.oldModel.medicalCommunity.physicians))
    },

    addPhysician () {
      // set physicians array reactive if not exists to enable save-button
      if (!this.model.medicalCommunity.physicians) {
        this.$set(this.model.medicalCommunity, 'physicians', [])
      }
      this.$set(this.model.medicalCommunity.physicians, this.model.medicalCommunity.physicians.length, {})
      // communicate to parent component to trigger save- and reset-button
      this.triggerArrayChanges()
    },

    deletePhysician (index) {
      this.$delete(this.model.medicalCommunity.physicians, index)
      // communicate to parent component to trigger save- and reset-button
      this.triggerArrayChanges()
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
